goog.provide("shadow.js.shim.module$photoswipe$default");
shadow.js.shim.module$photoswipe$default = shadow.js.require(85, {})["default"];
